import type { FC } from 'react';

import Typography from 'components/Typography/Typography';
import { DangerousIcon } from 'icons';

import { ErrorDetailsStyled, TitleStyled } from './ErrorSection.styled';

export type ErrorSectionPropsT = {
  statusReason?: string | null;
  errorDetails?: string;
};

const ErrorSection: FC<ErrorSectionPropsT> = ({ statusReason, errorDetails }) => {
  const getErrorMessage = (): string => {
    switch (statusReason) {
      case 'fetchTickets':
        return "Please contact your IT Security team to open access to network Get's and Post's for https://chirp.warrcloud.io";
      default:
        return 'Contact your warranty administrator at Warrcloud';
    }
  };

  return (
    <>
      <DangerousIcon size="13xl" color="red" />
      <Typography align="center" variant="h3" color="darkBlue">
        Something went wrong.
      </Typography>
      {errorDetails && (
        <ErrorDetailsStyled align="center" variant="h3" color="darkBlue">
          {errorDetails}
        </ErrorDetailsStyled>
      )}
      <TitleStyled align="center" variant="h3" color="darkBlue">
        {getErrorMessage()}
      </TitleStyled>
    </>
  );
};

export default ErrorSection;
